/* Entrega optimizada de fotografia: AVIF -> WebP -> JPG, variantes por ancho.
   Las derivadas las genera el backend en /api/img (cache inmutable). */

const ANCHOS = [480, 768, 1200, 1920];
const HOSTS_REMOTOS = ['images.unsplash.com', 'images.pexels.com'];

const rutaObjeto = (src) => {
  const m = String(src || '').match(/\/api\/files\/(.+)$/);
  return m ? m[1].split('?')[0] : null;
};

const esRemotaOptimizable = (src) => {
  const s = String(src || '');
  return /^https?:\/\//.test(s) && HOSTS_REMOTOS.some((h) => s.includes(h));
};

const url = (src, ancho, formato) =>
  esRemotaOptimizable(src)
    ? `/api/img/remoto?u=${encodeURIComponent(src)}&w=${ancho}&f=${formato}`
    : `/api/img/${src}?w=${ancho}&f=${formato}`;

const srcSet = (ruta, formato) => ANCHOS.map((w) => `${url(ruta, w, formato)} ${w}w`).join(', ');

/* Precarga del hero: <link rel="preload"> con el mismo srcset que usa la imagen. */
export function precargarImagen(src, sizes = '100vw') {
  const ruta = rutaObjeto(src) || (esRemotaOptimizable(src) ? src : null);
  if (!ruta || document.head.querySelector(`link[data-precarga="${ruta}"]`)) return;
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  link.type = 'image/avif';
  link.setAttribute('imagesrcset', srcSet(ruta, 'avif'));
  link.setAttribute('imagesizes', sizes);
  link.setAttribute('fetchpriority', 'high');
  link.setAttribute('data-precarga', ruta);
  document.head.appendChild(link);
}

export const Imagen = ({
  src,
  alt = '',
  ratio = 16 / 9,
  sizes = '100vw',
  prioridad = false,
  className = '',
  style,
  ...resto
}) => {
  const ruta = rutaObjeto(src) || (esRemotaOptimizable(src) ? src : null);
  const ancho = 1920;
  const alto = Math.round(ancho / (ratio || 16 / 9));
  const comunes = {
    alt,
    className,
    style,
    width: ancho,
    height: alto,
    decoding: 'async',
    loading: prioridad ? 'eager' : 'lazy',
    fetchPriority: prioridad ? 'high' : 'auto',
    ...resto,
  };

  if (!ruta) return <img src={src} {...comunes} />;

  return (
    <picture>
      <source type="image/avif" srcSet={srcSet(ruta, 'avif')} sizes={sizes} />
      <source type="image/webp" srcSet={srcSet(ruta, 'webp')} sizes={sizes} />
      <img src={url(ruta, 1200, 'jpg')} srcSet={srcSet(ruta, 'jpg')} sizes={sizes} {...comunes} />
    </picture>
  );
};
